import naja from 'naja';
import CustomCartSelect from './CustomCartSelect';

export default class Cart {
    private container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.init();
        this.initSnippetListener();
    }

    static init() {
        const container = document.querySelector('.base-cart') as HTMLElement;
        if (container) {
            new Cart(container);
        }
    }

    private init() {
        // Listen for quantity changes (assume .cart-quantity-input is the input/select for quantity)
        this.container.querySelectorAll<HTMLInputElement>('.cart-quantity-input').forEach((input) => {
            input.addEventListener('change', (e) => this.onQuantityChange(e));
        });

        // Listen for pricing select changes from CustomCartSelect component
        this.container.addEventListener('pricingSelectChange', (e) => this.onPricingSelectChange(e));
    }

    private onQuantityChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const productOrderId = input.dataset.productOrderId;
        const url = input.dataset.url;
        const quantity = input.value;
        if (!productOrderId || !url) return;
        const requestUrl = `${url}&productOrderId=${productOrderId}&quantity=${quantity}`;
        naja.makeRequest('GET', requestUrl, {
            history: false,
        });
    }

    private onPricingSelectChange(event: Event) {
        console.log('Cart: pricingSelectChange event received', event);

        const customEvent = event as CustomEvent;
        const detail = customEvent.detail;

        console.log('Cart: event detail', detail);

        // Find the hidden input to get productOrderId and url
        const container = (event.target as HTMLElement).closest('.select-container');
        if (!container) {
            console.log('Cart: No container found');
            return;
        }

        // Get data from the selected option or from the event detail
        let productOrderId: string | undefined;
        let url: string | undefined;

        if (detail.option) {
            // For regular options, get data from the option element
            productOrderId = detail.option.dataset.productOrderId;
            url = detail.option.dataset.url;
        } else {
            // For custom quantities, try to find data from any option
            const anyOption = container.querySelector('.option[data-product-order-id]') as HTMLElement;
            if (anyOption) {
                productOrderId = anyOption.dataset.productOrderId;
                url = anyOption.dataset.url;
            }
        }

        let quantity: string;
        if (detail.isCustom && detail.quantity) {
            quantity = detail.quantity.toString();
        } else {
            quantity = detail.value;
        }

        console.log('Cart: Making request', { productOrderId, url, quantity });

        if (!productOrderId || !url || !quantity) {
            console.log('Cart: Missing required data', { productOrderId, url, quantity });
            return;
        }

        // Make AJAX request
        const requestUrl = `${url}&productOrderId=${productOrderId}&quantity=${quantity}`;
        console.log('Cart: Request URL', requestUrl);

        naja.makeRequest('GET', requestUrl, {
            history: false,
        });
    }

    private initSnippetListener() {
        naja.snippetHandler.addEventListener('afterUpdate', (event: any) => {
            if (event.detail.snippet.id === 'snippet--cartProducts') {
                CustomCartSelect.init();
                this.init();
            }
        });
    }
}
